import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.85645 11.2227C11.6977 11.2227 13.9999 13.4388 14 16.1748C14 16.6303 13.6165 16.9999 13.1436 17H2.85645C2.3835 16.9999 2 16.6303 2 16.1748C2.00011 13.4388 4.30228 11.2227 7.14355 11.2227H8.85645ZM18.6123 6.95996C18.8257 6.74658 19.1723 6.74664 19.3857 6.95996H19.3838C19.5972 7.17339 19.5972 7.51997 19.3838 7.7334L15.0137 12.1045C14.8002 12.3179 14.4527 12.3179 14.2393 12.1045L12.0547 9.91895C11.8413 9.70552 11.8413 9.35893 12.0547 9.14551C12.2681 8.93231 12.6148 8.93216 12.8281 9.14551L14.627 10.9434L18.6123 6.95996ZM8 3C9.91239 3 11.4617 4.49149 11.4619 6.33301C11.4619 8.17467 9.9125 9.66699 8 9.66699C6.0875 9.66699 4.53809 8.17467 4.53809 6.33301C4.53827 4.49149 6.08761 3 8 3Z",
		fill: "#0D2976"
	})
});
export default SvgUserFilled;
